'use client';

import { Flex, Link, Typography } from '@coolblue-development/freddy';
import { SalesPrice, SalesPriceCurrent } from '@coolblue-development/next-sales-price/client';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

import { ProductTradeInContext } from './Context';

interface EntranceSummaryProps {
  openTradeInModal: () => void;
}

const EntranceSummary = ({ openTradeInModal }: EntranceSummaryProps) => {
  const { t } = useTranslation('webshop');
  const { summary, salesPrice = 0, entranceChoice } = useContext(ProductTradeInContext);
  const isTradable = !!(summary?.tradeInPrice && summary?.tradeInPrice > 0);

  return (
    <Flex gap={100} direction='column'>
      {isTradable ? (
        <Flex justifyContent='space-between'>
          <Typography component='span' m={0}>
            {t('productTradeIn.entrance.tradeInPrice')}
          </Typography>
          <SalesPrice
            size='small'
            currentPrice={
              <SalesPriceCurrent isSubtle={!entranceChoice} price={summary?.tradeInPrice ?? 0} />
            }
          />
        </Flex>
      ) : null}
      {isTradable ? (
        <Flex justifyContent='space-between'>
          <Typography component='span' m={0}>
            {t('productTradeIn.entrance.priceAfterTradeIn')}
          </Typography>
          <SalesPrice
            size='small'
            currentPrice={
              <SalesPriceCurrent isSubtle price={salesPrice - (summary?.tradeInPrice ?? 0)} />
            }
          />
        </Flex>
      ) : null}
      <Flex justifyContent='space-between'>
        <Typography
          component={isTradable ? 'span' : undefined}
          m={0}
          variant={isTradable ? 'caption' : 'body'}
        >
          {isTradable
            ? t('productTradeIn.entrance.tradeInInstructions')
            : t('productTradeIn.entrance.recycleProduct')}
        </Typography>
      </Flex>
      <Link
        component='button'
        type='button'
        onClick={openTradeInModal}
        aria-label={t('productTradeIn.entrance.ariaLabelLink')}
        sx={{ display: 'inline-flex' }}
      >
        {t('productTradeIn.modifyButtonLabel')}
      </Link>
    </Flex>
  );
};

export default EntranceSummary;
